
export class StartBackupOperationResult {
    responsibleNode: string;
    operationId: number;
}
